export default __webpack_public_path__ + "static/media/male.25d1cf54.jpg";